/*===================================================================
=             ROOT REDUCER                            =
====================================================================*/
/**
 * Combine all reducers into a single root reducer.
 */

import { combineReducers } from "redux";
import { IFilterState } from "../features/filter/redux/filter.reducer";
import filterReducer from "../features/filter/redux/filter.reducer";
import minigridReducer, {
  IMinigridState,
} from "../features/minigrid/redux/minigrid.reducer";
import { IStateAuthReducer } from "../features/auth/redux/auth.reducer";
import authReducer from "../features/auth/redux/auth.reducer";
import planBTReducer, {IPlanBTState} from "../features/planBT/redux/planBT.reducer";

// Reducers

/*======== TYPES =========== */
export interface IRootState {
  filter: IFilterState;
  minigrid: IMinigridState;
  auth: IStateAuthReducer;
  planBT: IPlanBTState;
}

/*======== ROOT REDUCER =========== */
const appReducer = combineReducers({
  filter: filterReducer,
  minigrid: minigridReducer,
  auth: authReducer,
  planBT: planBTReducer,
});

export const rootReducer = (state: any, action: never) => {
  return appReducer(state, action);
};

export default rootReducer;
